const MODAL_CONFIRM_CONFIG = {
  backdrop: false,
  ignoreBackdropClick: true,
  class: 'gray modal-confirm',
  id: 1
};
export default MODAL_CONFIRM_CONFIG;
